import React from 'react';
import { cn } from '../lib/utils';

/**
 * Decorative circuit-line section divider.
 * Orbe centré (flex) + ligne à 50% — axe vertical stable même avec le pulse.
 */
const CircuitDivider = ({ className }) => (
  <div className={cn('circuit-divider', className)} aria-hidden="true">
    <span className="circuit-divider-line" />
    <span className="circuit-divider-node" />
  </div>
);

export default CircuitDivider;
